import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Icon from '../Icon';
import { qualitySelectOptions } from '../ariHelpers';
import { selectSx } from './ComponentsStyles';
import { capitalizeSentence } from '../../../../utils/usefulFunctions';
import useTranslate from '../../../../customHooks/useTranslate';

const QualityFilter = ({ value, label, ...rest }) => {
    const translate = useTranslate();
    const id = 'quality-filter';
    const emptyOptionText = '';
    const options = qualitySelectOptions.map(option => ({
        ...option,
        text: translate(option.text),
    }));

    const translatedLabel = capitalizeSentence(translate(label));

    return (
        <FormControl sx={selectSx.container}>
            <InputLabel
                id={id}
                sx={{
                    ...selectSx.label,
                    top: typeof value === 'string' && !value ? '-7px' : '2px',
                }}
            >
                {translatedLabel}
            </InputLabel>
            <Select
                size='small'
                labelId={id}
                id={id}
                value={value}
                sx={selectSx.select}
                {...rest}
            >
                <MenuItem sx={selectSx.menuItem} value=''>
                    <span style={{ height: 24 }}>{emptyOptionText}</span>
                </MenuItem>
                {options.map(option => (
                    <MenuItem
                        sx={selectSx.menuItem}
                        key={option.text}
                        value={option.value}
                    >
                        <div className='flex flex-align-center gap-8'>
                            <Icon
                                iconName={option.iconName}
                                sx={{ color: option.color, fontSize: 20 }}
                            />
                            {option.text}
                        </div>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default QualityFilter;
